import {
	BCInput,
	BCInputNumber,
	BCModal,
	BCTag,
	BCInputRef,
	IInputChangeEventArgs,
	findMessage,
	BCNotification
} from '@bimser/components';
import * as React from 'react';
import Style from '../../assets/style.scss';
import IconAdd from '@bimser/icons/16/add';
import { ServiceList } from '@bimser/common';

interface ISettingsProps {
	closeModal: () => void;
	visible: boolean;
}
interface ISettings {
	emailAddresses: Array<string>;
	userCountFillPercent: number;
	projectCountFillPercent: number;
	licenseExpireDateRemainDay: number;
}

const SettingsModal = (props: ISettingsProps) => {
	const [data, setData] = React.useState<ISettings>({
		emailAddresses: [],
		userCountFillPercent: 0,
		projectCountFillPercent: 0,
		licenseExpireDateRemainDay: 0
	});
	const [inputVisible, setInputVisible] = React.useState<boolean>(false);
	const [inputValue, setInputValue] = React.useState<string>('');
	const inputRef = React.createRef<BCInputRef>();

	const handleCancel = () => {
		props.closeModal();
	};

	const handleOkClick = () => {
		ServiceList.web.License.SetSettings.callPromise(data)
			.then(response => {
				if (response) {
					BCNotification.success({ message: findMessage.get('103324'), autoClose: 3000 });
					handleCancel();
				} else {
					BCNotification.warning({ message: findMessage.get('103325'), autoClose: 3000 });
				}
			})
			.catch(() => {
				BCNotification.warning({ message: findMessage.get('103325'), autoClose: 3000 });
			});
	};

	const getSettings = () => {
		ServiceList.web.License.GetSettings.callPromise().then(data => {
			if (data.settings) {
				setData(data.settings);
			}
		});
	};

	React.useEffect(() => {
		getSettings();
	}, []);

	React.useEffect(() => {
		if (inputVisible) {
			inputRef.current?.focus();
		}
	}, [inputVisible]);

	const removeEmail = email => {
		setDataValue(
			'emailAddresses',
			data.emailAddresses.filter(item => item != email)
		);
	};

	const setDataValue = (key: string, value: any) => {
		setData({
			...data,
			[key]: value
		});
	};

	const handleInputChange = (e: IInputChangeEventArgs) => {
		setInputValue(e.data);
	};

	const handleInputConfirm = () => {
		if (inputValue && !data.emailAddresses.includes(inputValue)) {
			setDataValue('emailAddresses', [...data.emailAddresses, inputValue]);
		}
		setInputVisible(false);
		setInputValue('');
	};

	const showInput = () => {
		setInputVisible(true);
	};

	const renderContent = () => {
		const lisansMessageArr = findMessage.get('103319').split('{0}');
		const userMessageArr = findMessage.get('103320').split('{0}');
		const projectMessageArr = findMessage.get('103321').split('{0}');
		return (
			<div className={Style.settingsModalContent}>
				<div>
					{lisansMessageArr[0]}
					<BCInputNumber
						className={Style.inputNumber}
						value={data.licenseExpireDateRemainDay}
						onChange={(value: number) =>
							setDataValue('licenseExpireDateRemainDay', value)
						}
						min={0}
					/>
					{lisansMessageArr[1]}
				</div>
				<div className={Style.marginTop8}>
					{userMessageArr[0]}
					<BCInputNumber
						className={Style.inputNumber}
						value={data.userCountFillPercent}
						onChange={(value: number) => setDataValue('userCountFillPercent', value)}
						min={0}
						max={100}
					/>
					{userMessageArr[1]}
				</div>
				<div className={Style.marginTop8}>
					{projectMessageArr[0]}
					<BCInputNumber
						className={Style.inputNumber}
						value={data.projectCountFillPercent}
						onChange={(value: number) => setDataValue('projectCountFillPercent', value)}
						min={0}
						max={100}
					/>
					{projectMessageArr[1]}
				</div>
				<p className={Style.userInfoTitle}>{findMessage.get('103318')}</p>
				<div className={Style.emailList}>
					{data.emailAddresses?.map(
						(t, i) =>
							t && (
								<BCTag
									key={i}
									text={t.toString()}
									closable
									onClose={() => removeEmail(t)}
								/>
							)
					)}

					{inputVisible ? (
						<BCInput
							ref={inputRef}
							type="text"
							size="small"
							className={Style.emailInput}
							value={inputValue}
							onChange={handleInputChange}
							onBlur={handleInputConfirm}
							onPressEnter={handleInputConfirm}
						/>
					) : (
						<BCTag
							text={<IconAdd onClick={showInput} />}
							key={'newEmail'}
							className={Style.emailButton}
						/>
					)}
				</div>
			</div>
		);
	};

	return (
		<div>
			<BCModal
				title={findMessage.get('103313')}
				maskClosable
				closable
				disableScroll
				visible={props.visible}
				width={'600px'}
				okText={findMessage.get('100620')}
				cancelText={findMessage.get('100824')}
				handleCancel={handleCancel}
				handleOk={handleOkClick}
				className={Style.settingModalContainer}
			>
				{renderContent()}
			</BCModal>
		</div>
	);
};

export default SettingsModal;
